import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex h-2 w-2" }

enum OrderPaymentStatus {
  PROCESSING = 'processing',
  AUTHORIZED = 'authorized',
  PAID = 'paid',
  REFUNDED = 'refunded',
  PENDING = 'pending',
  PENDING_REFUND = 'pending_refund',
  REFUSED = 'refused',
  CHARGEDBACK = 'chargeback',
  ANALYZING = 'analyzing',
  PENDING_REVIEW = 'pending_review',
  CHECKOUT_ABANDONED = 'checkout_abandoned',
  AWAITING = 'awaiting',
  RECURRENCY = 'recurrency',
  CANCELED = 'canceled',
  PARTIAL_REFUND = 'partial_refund',
  EXPIRED_BILLET = 'expired_billet',
  PAYMENT_FAILED = 'payment_failed'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentStatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const OrderPaymentStatusLabels = {
  [OrderPaymentStatus.PROCESSING]: 'Processando',
  [OrderPaymentStatus.AUTHORIZED]: 'Autorizado',
  [OrderPaymentStatus.PAID]: 'Pago',
  [OrderPaymentStatus.REFUNDED]: 'Reembolsado',
  [OrderPaymentStatus.PENDING]: 'Pendente',
  [OrderPaymentStatus.PENDING_REFUND]: 'Pendente de reembolso',
  [OrderPaymentStatus.REFUSED]: 'Recusado',
  [OrderPaymentStatus.CHARGEDBACK]: 'Devolvido',
  [OrderPaymentStatus.ANALYZING]: 'Analisando',
  [OrderPaymentStatus.PENDING_REVIEW]: 'Pendente de revisão',
  [OrderPaymentStatus.CHECKOUT_ABANDONED]: 'Checkout abandonado',
  [OrderPaymentStatus.AWAITING]: 'Aguardando',
  [OrderPaymentStatus.RECURRENCY]: 'Recorrencia',
  [OrderPaymentStatus.CANCELED]: 'Cancelado',
  [OrderPaymentStatus.PARTIAL_REFUND]: 'Reembolso parcial',
  [OrderPaymentStatus.EXPIRED_BILLET]: 'Boleto expirado',
  [OrderPaymentStatus.PAYMENT_FAILED]: 'Pagamento falhou',
}

const statusClasses = {
  [OrderPaymentStatus.PROCESSING]: 'bg-yellow-500 text-yellow-50 bg-yellow-500/10',
  [OrderPaymentStatus.AUTHORIZED]: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
  [OrderPaymentStatus.PAID]: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
  [OrderPaymentStatus.REFUNDED]: 'bg-orange-500 text-orange-50 bg-orange-500/10',
  [OrderPaymentStatus.PENDING]: 'bg-blue-500 text-blue-50 bg-blue-500/10',
  [OrderPaymentStatus.PENDING_REFUND]: 'bg-yellow-500 text-yellow-50 bg-yellow-500/10',
  [OrderPaymentStatus.REFUSED]: 'bg-red-500 text-red-50 bg-red-500/10',
  [OrderPaymentStatus.CHARGEDBACK]: 'bg-red-500 text-red-50 bg-red-500/10',
  [OrderPaymentStatus.ANALYZING]: 'bg-blue-500 text-blue-50 bg-blue-500/10',
  [OrderPaymentStatus.PENDING_REVIEW]: 'bg-yellow-500 text-yellow-50 bg-yellow-500/10',
  [OrderPaymentStatus.CHECKOUT_ABANDONED]: 'bg-gray-500 text-gray-50 bg-gray-500/10',
  [OrderPaymentStatus.AWAITING]: 'bg-yellow-500 text-yellow-50 bg-yellow-500/10',
  [OrderPaymentStatus.RECURRENCY]: 'bg-purple-500 text-purple-50 bg-purple-500/10',
  [OrderPaymentStatus.CANCELED]: 'bg-red-500 text-red-50 bg-red-500/10',
  [OrderPaymentStatus.PARTIAL_REFUND]: 'bg-orange-500 text-orange-50 bg-orange-500/10',
  [OrderPaymentStatus.EXPIRED_BILLET]: 'bg-red-500 text-red-50 bg-red-500/10',
  [OrderPaymentStatus.PAYMENT_FAILED]: 'bg-red-500 text-red-50 bg-red-500/10',
}



return (_ctx: any,_cache: any) => {
  return (statusClasses[_ctx.status])
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([
      'inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-medium',
      statusClasses[_ctx.status],
    ])
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass([
          'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
          statusClasses[_ctx.status].split(' ')[0],
        ])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass([
          'relative inline-flex h-2 w-2 rounded-full',
          statusClasses[_ctx.status].split(' ')[0],
        ])
          }, null, 2)
        ]),
        _createTextVNode(" " + _toDisplayString(OrderPaymentStatusLabels[_ctx.status]), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})